import React from 'react';
import cn from 'bem-cn';

import './TagList.scss';
import { Tag } from '../UI';
import { TagListProps } from './TagList.types';

const b = cn('tag-list');

export const TagList: React.FC<TagListProps> = ({ tags, maxVisible = 2 }) => {
    const hasMoreTags = tags && tags.length > maxVisible;
    const remainingCount = tags && tags.length - maxVisible;

    return (
        <div className={b()}>
            {tags && tags.slice(0, maxVisible).map((tag, index) => <Tag key={index} text={tag} />)}
            {hasMoreTags && <Tag text={`+${remainingCount}`} />}
        </div>
    );
};
